import { useMutation } from '@tanstack/react-query';
import {
  type Templating_SaveTemplateInput,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { toast } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import { templatesKeys } from './keys';

const saveTemplate = graphql(/* GraphQL */ `
  mutation templating_saveTemplate($input: Templating_SaveTemplateInput) {
    templating_saveTemplate(input: $input) {
      success
    }
  }
`);

export function useSaveTemplate() {
  const { t } = useTranslation(['templates', 'common']);

  return useMutation({
    mutationFn: async (input: Templating_SaveTemplateInput) =>
      gqlClient.request(saveTemplate, { input }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: templatesKeys.all,
      });
      toast.success(t('templates:savedSuccessfullyMessage'));
    },
    onError: () => {
      toast.error(t('common:snackbarMessages.errorFailed'));
    },
  });
}
